/** 教师相关接口 */
import path from '@/api/index'
import {
  axios
} from '@/utils/request'
import parsePageParams from '@/utils/page'
import {axiosFile} from "../../utils/request";

// 分页
export function queryList (data) {
  return axios({
    url: path.mobile + '/trainRecord',
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}// 分页
export function add (data) {
  return axios({
    url: path.mobile + '/trainRecord/add',
    method: 'POST',
    data: data
  })
}// 分页
export function update (data) {
  return axios({
    url: path.mobile + '/trainRecord/update',
    method: 'POST',
    data: data
  })
}
export function getById (data) {
  return axios({
    url: path.mobile + '/trainRecord/getById',
    method: 'GET',
    params: data
  })
}
export function getXsSum () {
  return axios({
    url: path.mobile + '/trainRecord/getXsSum',
    method: 'GET'
  })
}
export function getUserInfo () {
  return axios({
    url: path.mobile + '/trainRecord/getUserInfo',
    method: 'GET'
  })
}
// 导入
export function template (data) {
  return axiosFile({
    url: path.mobile + '/trainRecord/template',
    method: 'POST',
    data: data
  })
}


// 导入



export function importExcel (file) {
  const data = new FormData()
  data.append('file', file)
  return axios({
    url: path.mobile + '/trainRecord/importExcel',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 1800000,
    data: data
  })
}

// 删除
export function del (data) {
  return axios({
    url: path.mobile + '/trainRecord',
    method: 'DELETE',
    data: data
  })
}
